<i18n src="./resources/locales.json"></i18n>

<template>
  <div id="login_wrapper" :dark="$vuetify.theme.dark">
    <v-card class="message-container" color="transparent" elevation="0">
      <div class="logo">
        <v-img class="img-logo" :src="require('@/assets/xtium_white_x_mark.svg')" max-height="48" max-width="48" />
      </div>
      <div>
        <v-card-title class="card-title">
          <div v-if="title">{{ title }}</div>
          <div v-else v-once>{{ $t('title') }}</div>
        </v-card-title>
        <v-card-text>
          <div v-if="message" class="message">{{ message }}</div>
          <div v-else v-once class="message">{{ $t('message') }}</div>
        </v-card-text>
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'EcsLogin',

  props: {
    title: {
      type: String,
      default: ''
    },
    message: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      loginToast: false,
      loginToastTimeout: 1500
    };
  },

  methods: {
    showLoginFailure() {
      this.loginToast = true;
    }
  }
};
</script>

<style scoped>
.message-container {
  display: grid;
  grid-template-columns: 72px auto 72px;
  transform: scale(1.5);
}

.logo {
  align-items: center;
}

.img-logo {
  display: block;
  margin: 24px 4px 0 auto;
}

[dark] .img-logo {
  filter: saturate(0) brightness(5);
  opacity: 0.8;
}

.card-title {
  padding: 16px 0 2px 16px !important;
  color: #fff;
}

.message {
  font-size: 14px;
  padding-bottom: 8px;
  opacity: 0.75;
  color: #fff;
}

#login_wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  background: linear-gradient(90deg, #001718 25%, #034c57 100%);
}
</style>
